// Healthy Device Status'
export enum HealthyStatus {
  JDEVICE_ONLINE = 'JDEVICE_ONLINE',
  PTR_SUE_COVER_OK = 'PTR_SUE_COVER_OK',
  PTR_SUE_REC_PAPEROK = 'PTR_SUE_REC_PAPEROK',
  PTR_SUE_SLP_PAPEROK = 'PTR_SUE_SLP_PAPEROK',
  PTR_SUE_SLP_EMPTY = 'PTR_SUE_SLP_EMPTY',
  PTR_SUE_SLP_NEAREMPTY = 'PTR_SUE_SLP_NEAREMPTY',
  CASH_SUE_DRAWERCLOSED = 'CASH_SUE_DRAWERCLOSED',
  WEIGHT_ZERO = 'WEIGHT_ZERO',
  STABLE_WEIGHT = 'STABLE_WEIGHT',
  SCL_SUE_WEIGHT_ZERO = 'SCL_SUE_WEIGHT_ZERO',
}
